import AppLogoIcon from '@/components/layout/app-logo-icon';
import { home } from '@/routes/admin';
import { type SharedData } from '@/types';
import { Link, usePage } from '@inertiajs/react';
import { type PropsWithChildren } from 'react';

interface AuthLayoutProps {
    title?: string;
    description?: string;
    image: string;
}

export default function AuthSplitLayout({
    children,
    title,
    description,
    image,
}: PropsWithChildren<AuthLayoutProps>) {
    const { name } = usePage<SharedData>().props;

    return (
        <div className="dark relative min-h-dvh overflow-hidden bg-[#081421] lg:flex">
            <img
                src={image}
                alt=""
                className="absolute inset-0 size-full object-cover"
            />
            <div
                aria-hidden
                className="absolute inset-0 bg-gradient-to-br from-[#1c3650]/80 via-[#081421]/50 to-[#081421]/85"
            />

            <div className="relative flex min-h-dvh w-full flex-col border-[#1d3147] bg-[#081421]/75 p-6 text-white backdrop-blur-2xl md:p-10 lg:w-[34rem] lg:shrink-0 lg:border-r xl:w-[38rem] xl:px-16">
                <Link
                    href={home()}
                    className="flex items-center gap-3 text-lg font-semibold"
                >
                    <AppLogoIcon className="size-9 fill-current" />
                    {name}
                </Link>

                <div className="flex flex-1 items-center">
                    <div className="flex w-full max-w-sm flex-col gap-8">
                        <div className="space-y-2">
                            <h1 className="text-3xl font-semibold tracking-tight">
                                {title}
                            </h1>
                            <p className="text-sm text-balance text-white/70">
                                {description}
                            </p>
                        </div>
                        {children}
                    </div>
                </div>

                <p className="text-xs text-white/50">
                    Staff and administrator access only.
                </p>
            </div>

            <div className="relative hidden flex-1 items-end p-12 lg:flex xl:p-16">
                <p className="max-w-lg text-4xl leading-tight font-semibold tracking-tight text-white drop-shadow-lg xl:text-5xl">
                    <span className="block">Every room.</span>
                    <span className="block">Every guest.</span>
                    <span className="block text-[#4a93c9]">One desk.</span>
                </p>
            </div>
        </div>
    );
}
